import { Button } from "../../tailwind/button";
import { Input } from "../../tailwind/input";
import { Label } from "../../tailwind/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../tailwind/select";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "../../tailwind/sheet";
import { CONTACTS_PRIMARY_BUTTON_CLASS } from "../../../pages/whatsapp/data/contactsData";
import { cn } from "../../../lib/utils";

function FieldError({ message }) {
  if (!message) return null;
  return <p className="text-xs text-red-600 dark:text-red-400 mt-1">{message}</p>;
}

export default function AddContactSheet({
  open,
  onOpenChange,
  form,
  errors = {},
  saving = false,
  leadStatusOptions = [],
  onChange,
  onSave,
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="sm:max-w-md overflow-y-auto bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800">
        <SheetHeader>
          <SheetTitle>Add Contact</SheetTitle>
          <SheetDescription>Manually add a new contact to your CRM.</SheetDescription>
        </SheetHeader>

        <div className="space-y-5 py-6">
          <div className="space-y-2">
            <Label htmlFor="contact-name">
              Name <span className="text-red-500">*</span>
            </Label>
            <Input
              id="contact-name"
              name="add-contact-name"
              autoComplete="name"
              placeholder="John Doe"
              value={form.name}
              maxLength={100}
              onChange={(event) => onChange("name", event.target.value)}
              className={cn(
                "bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800",
                errors.name ? "border-red-500 dark:border-red-500" : ""
              )}
              aria-invalid={Boolean(errors.name)}
            />
            <FieldError message={errors.name} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="contact-phone">
              Phone <span className="text-red-500">*</span>
            </Label>
            <Input
              id="contact-phone"
              name="add-contact-phone"
              type="tel"
              autoComplete="tel"
              placeholder="+91 98765 43210"
              value={form.phone}
              maxLength={20}
              onChange={(event) => onChange("phone", event.target.value)}
              className={cn(
                "bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800",
                errors.phone ? "border-red-500 dark:border-red-500" : ""
              )}
              aria-invalid={Boolean(errors.phone)}
            />
            <FieldError message={errors.phone} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="contact-email">Email</Label>
            <Input
              id="contact-email"
              name="add-contact-email"
              autoComplete="email"
              placeholder="john@example.com"
              type="email"
              value={form.email}
              maxLength={254}
              onChange={(event) => onChange("email", event.target.value)}
              className={cn(
                "bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800",
                errors.email ? "border-red-500 dark:border-red-500" : ""
              )}
              aria-invalid={Boolean(errors.email)}
            />
            <FieldError message={errors.email} />
          </div>
          <div className="space-y-2">
            <Label>Lead Status</Label>
            {leadStatusOptions.length > 0 ? (
              <Select
                value={form.leadStatus}
                onValueChange={(value) => onChange("leadStatus", value)}
              >
                <SelectTrigger
                  className={cn(
                    "bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800",
                    errors.leadStatus ? "border-red-500 dark:border-red-500" : ""
                  )}
                  aria-invalid={Boolean(errors.leadStatus)}
                >
                  <SelectValue placeholder="Select status..." />
                </SelectTrigger>
                <SelectContent>
                  {leadStatusOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            ) : (
              <Input
                placeholder="e.g. Warm, New Lead"
                value={form.leadStatus}
                maxLength={50}
                onChange={(event) => onChange("leadStatus", event.target.value)}
                className={cn(
                  "bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800",
                  errors.leadStatus ? "border-red-500 dark:border-red-500" : ""
                )}
                aria-invalid={Boolean(errors.leadStatus)}
              />
            )}
            <FieldError message={errors.leadStatus} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="contact-tags">Tags</Label>
            <Input
              id="contact-tags"
              placeholder="Comma-separated tags"
              value={form.tags}
              maxLength={500}
              onChange={(event) => onChange("tags", event.target.value)}
              className={cn(
                "bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800",
                errors.tags ? "border-red-500 dark:border-red-500" : ""
              )}
              aria-invalid={Boolean(errors.tags)}
            />
            <FieldError message={errors.tags} />
          </div>
          <Button
            className={`w-full ${CONTACTS_PRIMARY_BUTTON_CLASS}`}
            onClick={onSave}
            disabled={saving}
          >
            {saving ? "Saving…" : "Save Contact"}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
